<template>
    <v-row>
        <v-col
                cols="12"
                md="6"
        >
            <v-card>
                <v-form
                        ref="companyForm"
                        v-model="isValid"
                >
                    <v-card-text>
                        <v-container
                                class="pb-0"
                                fluid
                        >
                            <v-row class="pb-0">
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule,lengthRule(50)]"
                                            label="Name"
                                            v-model="company.name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                            :disabled="isLoading"
                                            :items="companyStatuses"
                                            item-text="value"
                                            item-value="key"
                                            label="Company Status"
                                            v-model="company.companyStatus"
                                    ></v-select>
                                </v-col>
                                <v-divider></v-divider>
                                <v-col cols="12">
                                    <v-file-input
                                            :disabled="isLoading"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Application Document"
                                            placeholder="Set Application Document"
                                            v-model="applicationForm"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                    @click.stop="
                                                    getFile(
                                                        company.applicationFormFileId,
                                                        'company_' +
                                                            company.id +
                                                            '_application-form_' +
                                                            company.applicationFormFileId
                                                    )
                                                "
                                                    elevation="1"
                                                    fab
                                                    small
                                                    v-show="
                                                    company.applicationFormFileId >
                                                    0
                                                "
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>

                                <v-col cols="12">
                                    <v-file-input
                                            :disabled="isLoading"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Letter Of Good Standing"
                                            placeholder="Set Letter Of Good Standing"
                                            v-model="letterOfGoodStanding"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                    @click.stop="
                                                    getFile(
                                                        company.letterOfGoodStandingFileId,
                                                        'company_' +
                                                            company.id +
                                                            '_letter-of-good-standing_' +
                                                            company.letterOfGoodStandingFileId
                                                    )
                                                "
                                                    elevation="1"
                                                    fab
                                                    small
                                                    v-show="
                                                    company.letterOfGoodStandingFileId >
                                                    0
                                                "
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>

                                <v-divider></v-divider>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="RegistrationNumber"
                                            v-model="company.registrationNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="VatNumber"
                                            v-model="company.vatNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(50)]"
                                            label="Account Number"
                                            v-model="company.accountNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Address line 1"
                                            v-model="company.address1"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Address line2"
                                            v-model="company.address2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Address line 3"
                                            v-model="company.address3"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Address line 4"
                                            v-model="company.address4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(500)]"
                                        label="Postal Address"
                                        v-model="company.postalAddress"
                                    ></v-text-field>
                                </v-col>
                                <v-divider></v-divider>
                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(30)]"
                                            label="Bank Name"
                                            v-model="company.bankName"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(30)]"
                                            label="Branch Code"
                                            v-model="company.bankBranchCode"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(30)]"
                                            label="Bank Account Number"
                                            v-model="company.bankAccountNumber"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                            :disabled="isLoading"
                                            :items="bankAccountTypes"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Account Type"
                                            v-model="company.bankAccountType"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="paymentPreferences"
                                        item-text="value"
                                        item-value="key"
                                        label="Payment Preference"
                                        v-model="company.paymentPreference"
                                    ></v-select>
                                </v-col>

                                <v-divider></v-divider>
                                <v-col cols="12">
                                    <v-select
                                            :disabled="isLoading"
                                            :items="brokers"
                                            :rules="[]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Broker"
                                            v-model="company.brokerId"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <br/>
                            <v-row
                                    align="end"

                                    justify="space-around"

                                    v-show="company.id > 0"
                            >
                                <v-col cols="6">
                                    <v-btn
                                            :disabled="isLoading"
                                            @click="showSmsForm()"
                                            class="text-none"
                                            color="secondary darken-1"

                                    >Send sms to all company customers
                                    </v-btn>
                                </v-col>
                                <v-col cols="6">

                                    <v-btn
                                            :disabled="(isLoading && !isSendingWelcome)"
                                            :loading="isSendingWelcome"
                                            @click="sendwelcomesmsesforcompanycustomers(company.id)"
                                            class="text-none"
                                            color="secondary darken-1"

                                    >Send welcome sms to all customers
                                    </v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn
                                            :disabled="(isLoading && !isSendingConsentSms)"
                                            :loading="isSendingConsentSms"
                                            @click="sendconsentsmsesforcompanycustomers(company.id)"
                                            class="text-none"
                                            color="secondary darken-1"

                                    >Send consent sms to all customers
                                    </v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn
                                            :disabled="(isLoading && !isSendingWelcomeContact)"
                                            :loading="isSendingWelcomeContact"
                                            @click="sendwelcomesmstocompanycontactpersons(company.id)"
                                            class="text-none"
                                            color="secondary darken-1"

                                    >Send welcome sms to contacts
                                    </v-btn>
                                </v-col>

                                <v-col cols="6">
                                    <v-btn
                                            :disabled="(isLoading && !isSendingCardSms)"
                                            :loading="isSendingCardSms"
                                            @click="sendcardsmsesforcompanycustomers(company.id)"
                                            class="text-none"
                                            color="secondary darken-1"

                                    >Send card sms to all company customers
                                    </v-btn>
                                </v-col>
                                <v-col cols="6"></v-col>
                            </v-row>

                            <br/>
                            <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                            >
                                <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="company.id > 0"
                                >Delete
                                </v-btn>
                                <v-btn
                                        :disabled="isLoading"
                                        @click="closeForm"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                >Close
                                </v-btn>
                                <v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                >{{ company.id > 0 ? "Update" : "Add" }}
                                </v-btn>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
                <v-dialog
                        persistent
                        v-model="smsFormVisible"
                        width="500px"
                >
                    <AccisureSmsCustomerForm
                            :company-id="company.id"
                            :key="company.id"
                            @close="closeSmsForm"
                    />
                </v-dialog>
                <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                >
                    {{ notifyMessage }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-col>
        <v-col
                cols="12"
                md="6"
                no-gutters
        >
            <v-col
                    cols="12"
                    v-show="company.id > 0"
            >
                <h3>
                    Notes
                    <v-btn
                            :disabled="isLoading"
                            @click="newNoteShow = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </h3>
                <v-col
                        :key="note.id"
                        cols="12"
                        justify="start"
                        no-gutters
                        v-for="note in company.companyNotes"
                >
                    <v-card>
                        <v-card-subtitle>
                            {{ note.author }}
                            <br/>
                            {{ note.createdAt }}
                        </v-card-subtitle>
                        <v-card-text>{{ note.text }}</v-card-text>
                    </v-card>
                </v-col>
            </v-col>
            <v-col
                    cols="12"
                    v-show="company.id > 0"
            >
                <company-contacts-list v-if="company"
                                       :company-id="company.id"
                                       :contacts="company.customerCompanyContacts"
                                       :company-contact-designations="companyContactDesignations"
                                       @contact-added="companyContactAdded"
                                       @contact-updated="companyContactUpdated"
                                       @contact-deleted="companyContactDeleted"
                                       @on-error="companyContactError"/>
            </v-col>
            <v-col
                    cols="12"
                    v-show="company.id > 0"
            >
                <company-invoices-list v-if="company"
                                       :company-id="company.id"
                                       :account-number="company.accountNumber"
                                       :payment-preference="company.paymentPreference"/>
            </v-col>
        </v-col>
        <v-dialog
                persistent
                v-model="newNoteShow"
                width="500px"
        >
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-textarea
                            :rules="[lengthRule(512)]"
                            counter
                            label="Note"
                            v-model="newNoteText"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            @click="
              () => {
                newNoteShow = false;
                newNoteText = '';
              }
            "
                            class="text-none"
                            color="secondary darken-1"
                            text
                    >Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                            :loading="newNoteAdding"
                            @click="newNoteAdd"
                            class="text-none"
                            color="secondary darken-1"
                            text
                    >Add
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import Company from "../../models/Company.model";
import AccisureSmsCustomerForm from "../forms/AccisureSmsCustomerForm";
import CompanyContactsList from "@/components/widgets/CompanyContacts/CompanyContactsList.vue";
import CompanyInvoicesList from "@/components/widgets/CompanyInvoices/CompanyInvoicesList.vue";
import CompanyService from "@/services/company.service";

export default {
    props: {
        companyIn: Company
    },
    components: {
        CompanyInvoicesList,
        CompanyContactsList,
        AccisureSmsCustomerForm
    },
    created: async function () {
        this.bankAccountTypes = await this.$store.dispatch("companies/getbankaccounttypes");
        this.companyStatuses = await this.$store.dispatch("companies/getCompanyStatuses");
        this.brokers = await this.$store.dispatch("brokers/getlist");
        this.companyContactDesignations = await this.$store.dispatch("companies/getCompanyContactDesignations");
        this.paymentPreferences = await CompanyService.getCompanyPaymentPreferences();
    },
    data() {
        return {
            company: new Company().set(this.companyIn),
            bankAccountTypes: null,
            paymentPreferences: null,
            applicationForm: [],
            letterOfGoodStanding: [],
            companyStatuses: [],
            brokers: [],
            companyContactDesignations: [],

            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            smsFormVisible: false,

            newContactAdding: false,
            newContactShow: false,

            newContact: {
                name: "",
                surname: "",
                email: "",
                number: "",
                designation: 1,
            },

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",

            isSendingWelcome: false,
            isSendingWelcomeContact: false,
            isSendingConsentSms: false,
            isSendingCardSms: false,
        };
    },
    methods: {
        sendwelcomesmsesforcompanycustomers(companyId) {
            this.isSendingWelcome = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendwelcomesmsesforcompanycustomers", {companyId: companyId})
                .then(
                    () => {
                        this.notify("Customer welcome messages sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },

        sendconsentsmsesforcompanycustomers(companyId) {
            this.isSendingConsentSms = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendconsentsmsesforcompanycustomers", {companyId: companyId})
                .then(
                    () => {
                        this.notify("Customer consent messages sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },

        sendwelcomesmstocompanycontactpersons(companyId) {
            this.isSendingWelcomeContact = true;
            this.isLoading = true;

            this.$store
                .dispatch("companies/sendwelcomesmstocompanycontactpersons", {companyId: companyId})
                .then(
                    () => {
                        this.notify("Contact welcome messages sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },

        sendcardsmsesforcompanycustomers(companyId) {
            this.isSendingCardSms = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendcustomercardsms", {companyId: companyId})
                .then(
                    () => {
                        this.notify("Customer card messages sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },

        closeSmsForm() {
            this.smsFormVisible = false;
        },
        showSmsForm() {
            this.smsFormVisible = true;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedCompany) {
            this.$emit("saved", savedCompany);
        },
        emitDeletedEntity(deletedCompany) {
            this.$emit("deleted", deletedCompany);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            return this.$refs.companyForm.validate();
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("ApplicationForm", this.applicationForm);
                formdata.append("LetterOfGoodStanding", this.letterOfGoodStanding);
                formdata.append("Model", JSON.stringify(this.company));

                const parameters = {
                    id: this.company.id,
                    formData: formdata
                };

                this.$store
                    .dispatch(
                        "companies/" +
                        (this.company.id == 0 ? "create" : "update"),
                        this.company.id == 0 ? parameters.formData : parameters
                    )
                    .then(
                        companyWithInfo => {
                            this.notify(
                                "Company successfully saved.",
                                "success"
                            );
                            if (this.company.id == 0) {
                                this.company.id = companyWithInfo.entity.id;
                            }
                            this.company.applicationFormFileId =
                                companyWithInfo.entity.applicationFormFileId;
                            this.applicationForm = null;

                            this.company.letterOfGoodStandingFileId =
                                companyWithInfo.entity.letterOfGoodStandingFileId;
                            this.letterOfGoodStanding = null;

                            this.emitSavedEntity(companyWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },

        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
            this.isSendingWelcomeContact = false;
            this.isSendingConsentSms = false;
            this.isSendingCardSms = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this company?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("companies/delete", this.company.id)
                    .then(
                        () => {
                            this.notify(
                                "Company successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.company);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("companies/addNote", {
                    companyId: this.company.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.company.companyNotes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteAddingDone();
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        },
        getDesignationDescription(key) {
            let designation = this.companyContactDesignations.find(d => d.key === key);
            if (designation) {
                return designation.value;
            }
            return '';
        },
        companyContactAdded(contact) {
            this.company.customerCompanyContacts.push(contact);
        },
        companyContactUpdated(contact) {
            let existingContact = this.company.customerCompanyContacts.find(c => c.id === contact.id);
            if (existingContact != null) {
                Object.assign(existingContact, contact);
            }
        },
        companyContactDeleted(contactId) {
            const deletedIndex = this.company.customerCompanyContacts.findIndex(
                x => x.id === contactId
            );
            if (deletedIndex > -1)
                this.company.customerCompanyContacts.splice(deletedIndex, 1);
            this.notify(
                "Contact successfully deleted.",
                "success"
            );
        },
        companyContactError(error) {
            this.notify(
                error,
                "error"
            );
        }
    }
};
</script>

<style lang="stylus" scoped></style>
